import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_list = _resolveComponent("v-list");
    return (_openBlock(), _createBlock(_component_v_list, {
        class: "common-scroll py-0 overflow-y-auto",
        width: _ctx.width,
        onScroll: _ctx.scrolling
    }, {
        default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                return _renderSlot(_ctx.$slots, "item", _mergeProps({ ref_for: true }, { item, index }));
            }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["width", "onScroll"]));
}
